import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from "@angular/core";
import {
  FormArray,
  FormControl,
  FormControlName,
  FormGroup,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { FileInput } from "src/app/models/support";

@Component({
    selector: "document-ticket",
    templateUrl: "./document-ticket.component.html",
    styleUrls: ["./document-ticket.component.scss"],
    standalone: false
})
export class DocumentTicketComponent implements OnInit, OnChanges {
  @Input() form: FormGroup;
  @Input() isVisible: boolean = false;
  @Input() category: string;
  constructor() {}

  ngOnInit(): void {}

  onFileSelect(file: FileInput, index: number) {
    this.documents.at(index).setValue({
      name: file.file.name,
      content: file.base64,
    });
  }

  onFileRemove(index: number) {
    this.documents.at(index).setValue("");
  }

  addFile() {
    const documentControl = new FormControl("", [Validators.required]);
    this.documents.push(documentControl);
  }

  deleteControl(index: number) {
    if (this.documents.length > 1)
      (this.form.get("documents") as FormArray).removeAt(index);
  }
  get message() {
    return this.form.get("message");
  }
  get documents() {
    return this.form.get("documents") as FormArray;
  }

  markAsTouched(index: number) {
    this.documents.at(index).markAsTouched();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.category) {
      if (this.isVisible) this.initiateForm();
    }
  }

  initiateForm() {
    this.form.addControl(
      "documents",
      new FormArray([new FormControl("", [Validators.required])])
    );
    this.form.addControl("message", new FormControl("", [Validators.required]));
  }
}
